function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Component } from 'react';
import config from 'react-global-configuration';
import { Formik, setNestedObjectValues } from 'formik';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import c from 'classnames';
import { WysiwygField, addUtmQueryString } from '@uncinc/uncinc-react-kitchen-sink';
import { FormikExtendedContextProvider } from '@uncinc/uncinc-react-kitchen-sink/dist/components/Form/FormikWrapper';
import WebformMapper from './WebformMapper';
var WebformComponent = /*#__PURE__*/function (_Component) {
  _inherits(WebformComponent, _Component);
  var _super = _createSuper(WebformComponent);
  function WebformComponent(props) {
    var _this;
    _classCallCheck(this, WebformComponent);
    _this = _super.call(this, props);
    /**
     * @description Scroll to the top of the webform component
     */
    _defineProperty(_assertThisInitialized(_this), "scrollToTop", function () {
      if (_this.webformRef.scrollIntoView) {
        _this.webformRef.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onNextPage", function () {
      var currentPage = _this.state.currentPage;
      _this.setState({
        currentPage: currentPage + 1
      }, function () {
        if (_this.props.scrollToTopAfterMultiFormStep) {
          _this.scrollToTop();
        }
        if (_this.props.onNextMultiFormStep) {
          _this.props.onNextMultiFormStep();
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onPreviousPage", function () {
      var currentPage = _this.state.currentPage;
      _this.setState({
        currentPage: currentPage - 1
      }, function () {
        if (_this.props.scrollToTopAfterMultiFormStep) {
          _this.scrollToTop();
        }
        if (_this.props.onPrevMultiFormStep) {
          _this.props.onPrevMultiFormStep();
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "collectPages", function (entities) {
      var output = new Immutable.List();
      entities.entrySeq().forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          entity = _ref2[1];
        var mappedEntity = Immutable.fromJS(entity);
        if (mappedEntity.get('#type') === 'webform_wizard_page') {
          output = output.push(mappedEntity.get('#webform_key'));
        }
      });
      return output;
    });
    /**
     * @description Determines the visibility based in Drupal #states.
     */
    _defineProperty(_assertThisInitialized(_this), "determineVisibility", function (entities, values) {
      var output = new Immutable.OrderedMap();
      var determineVisibilityForElement = function determineVisibilityForElement(state) {
        var visible = state.keySeq().every(function (component) {
          var condition = state.get(component);
          if (!condition) {
            return false;
          }
          var fieldName = component.match(/input\[name="(.+)"\]/)[1];

          // Determine the type of condition.
          if (condition.get('filled')) {
            if (values[fieldName]) {
              return true;
            }
          } else if (condition.get('empty')) {
            if (!values[fieldName]) {
              return true;
            }
          } else if (condition.get('value')) {
            var value = condition.get('value');
            // check if is object
            if (value && _typeof(value) === 'object') {
              // check if 'between'
              if (value.get('between')) {
                var betweenValues = value.get('between').split(':');
                if (values[fieldName]) {
                  if (betweenValues.length !== 2) {
                    console.log('The \'between\' condition supports two values divided by colon only.');
                  } else {
                    // if value between the condition
                    if (Number(values[fieldName]) >= Number(betweenValues[0]) && Number(values[fieldName]) <= Number(betweenValues[1])) {
                      return true;
                    }
                  }
                }
              }
            }
            // Check for subfield.
            var matches = _toConsumableArray(fieldName.matchAll(/(.*)\[(.*)\]/g));
            if (matches && matches.length > 0) {
              var _matches$ = _slicedToArray(matches[0], 2),
                field = _matches$[1];
              if (values[field]) {
                if (values[field].includes(value)) {
                  return true;
                }
              }
            }
            if (values[fieldName] === value) {
              return true;
            }
          } else if (condition.get('checked')) {
            // Check for subfield.
            var _matches = _toConsumableArray(fieldName.matchAll(/(.*)\[(.*)\]/g));
            if (_matches && _matches.length > 0) {
              var _matches$2 = _slicedToArray(_matches[0], 3),
                _field = _matches$2[1],
                subField = _matches$2[2];
              if (values[_field]) {
                if (values[_field].includes(subField)) {
                  return true;
                }
              }
            }
            if (values[fieldName] === true) {
              return true;
            }
          } else {
            console.log('Condition not yet supported:', condition);
          }
          // By default, states will make a field invisible.
          return false;
        });
        return visible;
      };
      entities.entrySeq().forEach(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          entity = _ref4[1];
        if (key.indexOf('#') === 0) {
          return;
        }
        var visible = true;
        if (entity.hasIn(['#states', 'visible']) || entity.hasIn(['#states', 'invisible'])) {
          var state = entity.hasIn(['#states', 'visible']) ? entity.getIn(['#states', 'visible']) : entity.getIn(['#states', 'invisible']);
          if (Immutable.Map.isMap(state)) {
            // State is a Map, which means a single condition.
            visible = determineVisibilityForElement(state);
          } else if (Immutable.List.isList(state)) {
            // State is a List, which means multiple conditions, separated by an operator (and, or, xor).
            var operator = 'or';
            visible = determineVisibilityForElement(state.get(0));
            state.slice(1).forEach(function (substate) {
              if (typeof substate === 'string') {
                operator = substate;
              } else if (Immutable.Map.isMap(substate)) {
                switch (operator) {
                  case 'and':
                    visible = visible && determineVisibilityForElement(substate);
                    break;
                  case 'or':
                    visible = visible || determineVisibilityForElement(substate);
                    break;
                  case 'xor':
                    visible = visible ^ determineVisibilityForElement(substate);
                    break;
                }
              }
            });
          }
        }

        // Flip the condition if the state is 'invisible'.
        if (entity.hasIn(['#states', 'invisible'])) {
          visible = !visible;
        }
        entity = entity.set('#visible', visible);

        // Recursively loop over children.
        var children = entity;
        children.keySeq().forEach(function (k) {
          if (k.indexOf('#') === 0) {
            children = children.delete(k);
          }
        });
        children = _this.determineVisibility(children, values);
        children.keySeq().forEach(function (v) {
          entity = entity.set(v, children.get(v));
        });
        entity = entity.merge(children);
        output = output.set(key, entity);
      });
      return output;
    });
    _defineProperty(_assertThisInitialized(_this), "collectInitialValuesFlat", function (entities) {
      var output = new Immutable.OrderedMap();
      entities.entrySeq().forEach(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
          key = _ref6[0],
          entity = _ref6[1];
        if (key.indexOf('#') === 0) {
          return;
        }
        var mappedEntity = Immutable.fromJS(entity);
        var defaultValueFromDrupal = mappedEntity.get('#default_value');
        var defaultValue = '';
        switch (mappedEntity.get('#type')) {
          case 'webform_entity_checkboxes':
          case 'webform_checkboxes_other':
          case 'webform_checkboxes':
          case 'checkboxes':
          case 'checkboxes_other':
          case 'entity_checkboxes':
            defaultValue = [];
            break;
          case 'webform_address':
            defaultValue = {
              'address': '',
              // street
              'address_2': '',
              // housenumber
              'city': '',
              'postal_code': '',
              'country': ''
            };
            break;
          case 'autocomplete_dutch_address':
            defaultValue = {
              'postcode': '',
              'housenumber': '',
              'housenumber_extension': '',
              'street': '',
              'city': '',
              'country': ''
            };
            break;
          case 'webform_name':
            defaultValue = {
              'first': '',
              'middle': '',
              'last': ''
            };
            break;
          default:
            defaultValue = defaultValueFromDrupal || '';
        }
        output = output.set(mappedEntity.get('#webform_key'), defaultValue);

        // Collect child items.
        var children = Immutable.fromJS(entity);
        children.keySeq().forEach(function (k) {
          if (k.indexOf('#') === 0) {
            children = children.delete(k);
          }
        });

        // Iterate over children and merge them.
        var c = _this.collectInitialValuesFlat(children);
        output = output.merge(c);
      });
      return output;
    });
    _defineProperty(_assertThisInitialized(_this), "hasWebformActions", function (elements) {
      var objectFound = false;
      // Check on type 'webform_actions'
      elements.entrySeq().forEach(function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
          key = _ref8[0],
          element = _ref8[1];
        if (key.indexOf('#') === 0) {
          return;
        }
        var entity = Immutable.fromJS(element);
        if (entity.get('#type') === 'webform_actions') {
          objectFound = true;
        }
        // Recursively loop over children if we have not found.
        if (!objectFound) {
          var children = entity;
          children.keySeq().forEach(function (k) {
            if (k.indexOf('#') === 0) {
              children = children.delete(k);
            }
          });
          objectFound = _this.hasWebformActions(children);
        }
      });
      return objectFound;
    });
    _this.state = {
      error: null,
      submitted: false,
      message: '',
      currentPage: 0
    };
    return _this;
  }
  _createClass(WebformComponent, [{
    key: "handleSuccessfulSubmit",
    value: function handleSuccessfulSubmit(data) {
      if (data.confirmation) {
        switch (data.confirmation.type) {
          case 'url':
            {
              window.location.href = addUtmQueryString(data.confirmation.url);
              break;
            }
          case 'message':
            {
              this.setState({
                submitted: true,
                message: data.confirmation.message
              });
              break;
            }
          case 'none':
          default:
            {
              break;
            }
        }
      } else {
        this.setState({
          submitted: true
        });
      }

      // Run custom function if it exists. Include submission response.
      this.props.onSuccessfullSubmit(data);
      if (this.props.scrollToTopAfterSubmit) {
        this.scrollToTop();
      }
    }
  }, {
    key: "handleFailedSubmit",
    value: function handleFailedSubmit(error) {
      this.setState({
        submitted: false,
        error: true
      });
      if (this.props.onFailedSubmit) {
        this.props.onFailedSubmit(error);
      }
    }
  }, {
    key: "submit",
    value:
    /**
     * Handles the submission of the form.
     *
     * @param {*} values
     *   The values to submit
     * @param {*} handleResponse
     *   Boolean indicating if we should have the response, e.g. display a message.
     *   Useful for auto-submission purposes.
     */
    function () {
      var _submit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(values) {
        var _this2 = this;
        var handleResponse,
          _this$props,
          id,
          language,
          onSubmit,
          API_URL,
          MULTILINGUAL,
          PATH,
          csrfToken,
          _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              handleResponse = _args.length > 1 && _args[1] !== undefined ? _args[1] : true;
              _this$props = this.props, id = _this$props.id, language = _this$props.language, onSubmit = _this$props.onSubmit;
              API_URL = config.get('API_URL');
              MULTILINGUAL = config.get('MULTILINGUAL', true);
              PATH = MULTILINGUAL ? "".concat(API_URL, "/").concat(language) : API_URL; // Replace the 'other' options with the actual value.
              Object.keys(values).map(function (key) {
                if (values[key] === '__other__') {
                  values[key] = values["".concat(key, "--other")];
                }
              });
              if (typeof onSubmit === 'function') {
                onSubmit(values);
              }
              _context.next = 9;
              return fetch("".concat(PATH, "/session/token"), {
                credentials: 'include'
              }).then(function (response) {
                return response.text();
              }).then(function (response) {
                csrfToken = response;
                fetch("".concat(PATH, "/webform_rest/submit"), {
                  method: 'POST',
                  credentials: 'include',
                  body: JSON.stringify(_objectSpread({
                    webform_id: id
                  }, values)),
                  headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': csrfToken
                  }
                }).then(function (response) {
                  return response.json();
                }).then(function (response) {
                  if (response.error) {
                    _this2.handleFailedSubmit(response.error);
                  } else if (handleResponse) {
                    _this2.handleSuccessfulSubmit(response);
                  }
                }).catch(function (e) {
                  _this2.handleFailedSubmit(e);
                });
              }).catch(function (e) {
                _this2.handleFailedSubmit(e);
              });
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function submit(_x2) {
        return _submit.apply(this, arguments);
      }
      return submit;
    }()
    /**
     * Check which fields are visible and filter out values for non-rendered fields
     */
  }, {
    key: "getValuesForVisibleFields",
    value: function getValuesForVisibleFields(allValues) {
      var _this3 = this;
      if (this.webformRef) {
        Object.keys(allValues).forEach(function (key) {
          var inputWithNameVisible = _this3.webformRef.querySelector("[name=\"".concat(key, "\"]"));
          var inputWithIdVisible = _this3.webformRef.querySelector("[id=\"".concat(key, "\"]"));
          var fieldVisible = inputWithNameVisible || inputWithIdVisible;
          if (fieldVisible) {
            return;
          }
          delete allValues[key];
        });
      }
      return allValues;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props2 = this.props,
        id = _this$props2.id,
        entities = _this$props2.entities,
        title = _this$props2.title,
        overriddenComponents = _this$props2.overriddenComponents,
        status = _this$props2.status,
        info = _this$props2.info,
        initialValues = _this$props2.initialValues,
        displayValidationErrorBottom = _this$props2.displayValidationErrorBottom;
      var _this$state = this.state,
        error = _this$state.error,
        submitted = _this$state.submitted,
        message = _this$state.message,
        currentPage = _this$state.currentPage;
      var pages = this.collectPages(entities);
      var initialDrupalValues = this.collectInitialValuesFlat(entities).toJS();
      // Merge the initial values into the Drupal values.
      var mergedValues = _objectSpread(_objectSpread({}, initialDrupalValues), initialValues);
      if (status && status === 'closed' && info) {
        var closedMessage = info.getIn(['settings', 'form_close_message'], 'Dit formulier is gesloten.');
        return /*#__PURE__*/React.createElement("div", {
          ref: function ref(node) {
            return _this4.webformRef = node;
          },
          className: "WebformComponent__closed"
        }, /*#__PURE__*/React.createElement(WysiwygField, {
          property: "schema:text",
          html: closedMessage,
          className: "WebformAddressAutocomplete__description WebformComponent--description"
        }));
      } else if (submitted === true) {
        return /*#__PURE__*/React.createElement("div", {
          ref: function ref(node) {
            return _this4.webformRef = node;
          },
          className: "WebformComponent__submitted"
        }, /*#__PURE__*/React.createElement(WysiwygField, {
          property: "schema:text",
          html: message,
          className: "WebformAddressAutocomplete__description WebformComponent--description"
        }));
      } else {
        var webformActions = this.hasWebformActions(entities);
        var webformWrapperClasses = c(Immutable.fromJS(entities).getIn(['#attributes', 'class'], Immutable.List()).toJS());
        return /*#__PURE__*/React.createElement("div", {
          className: webformWrapperClasses,
          ref: function ref(node) {
            _this4.webformRef = node;
          }
        }, /*#__PURE__*/React.createElement(Formik, {
          initialValues: mergedValues,
          onSubmit: function onSubmit(values, actions) {
            return _this4.submit(values);
          }
        }, function (props) {
          // Determine visibility.
          var entitiesMapped = _this4.determineVisibility(entities, props.values);
          if (!webformActions) {
            // No actions defined, so add them client-side.
            entitiesMapped = entitiesMapped.set('actions', Immutable.Map({
              '#type': 'webform_actions',
              '#submit__label': 'Versturen',
              '#webform': id,
              '#webform_id': "".concat(id, "--actions"),
              '#webform_key': 'actions',
              '#webform_plugin_id': 'webform_actions'
            }));
          }
          return /*#__PURE__*/React.createElement(FormikExtendedContextProvider, null, title && /*#__PURE__*/React.createElement("div", {
            className: "WebformParagraph__title-wrapper"
          }, /*#__PURE__*/React.createElement("h3", {
            className: "WebformParagraph__title"
          }, title)), /*#__PURE__*/React.createElement("div", {
            className: "WebformComponent__form"
          }, /*#__PURE__*/React.createElement(WebformMapper, _extends({}, props, _this4.props, {
            id: id,
            entities: entitiesMapped,
            overriddenComponents: overriddenComponents,
            pages: pages,
            onNextPage: _this4.onNextPage,
            onPreviousPage: _this4.onPreviousPage,
            currentPage: pages.get(currentPage),
            handleSubmit: /*#__PURE__*/function () {
              var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(handleResponse) {
                var validationErrors, submitValues;
                return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2;
                      return props.validateForm();
                    case 2:
                      validationErrors = _context2.sent;
                      if (!(Object.keys(validationErrors).length > 0)) {
                        _context2.next = 6;
                        break;
                      }
                      props.setTouched(setNestedObjectValues(validationErrors, true));
                      return _context2.abrupt("return");
                    case 6:
                      submitValues = _this4.props.onlySubmitVisibleFields ? _this4.getValuesForVisibleFields(props.values) : props.values;
                      props.setSubmitting(true);
                      _context2.next = 10;
                      return _this4.submit(submitValues, handleResponse);
                    case 10:
                      props.setSubmitting(false);
                    case 11:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              }));
              return function (_x3) {
                return _ref9.apply(this, arguments);
              };
            }()
          })), error && /*#__PURE__*/React.createElement("div", {
            className: "WebformComponent_error WebformComponent--error"
          }, _this4.props.t(['webform.general_error', 'webform_general_error'])), displayValidationErrorBottom && Object.keys(props.errors).length !== 0 && displayValidationErrorBottom));
        }));
      }
    }
  }]);
  return WebformComponent;
}(Component);
WebformComponent.propTypes = {
  displayValidationErrorBottom: PropTypes.element,
  scrollToTopAfterSubmit: PropTypes.bool,
  scrollToTopAfterMultiFormStep: PropTypes.bool,
  onSuccessfullSubmit: PropTypes.func,
  onFailedSubmit: PropTypes.func,
  initialValues: PropTypes.shape,
  onSubmit: PropTypes.func,
  t: PropTypes.func,
  onNextMultiFormStep: PropTypes.func,
  onPrevMultiFormStep: PropTypes.func,
  onlySubmitVisibleFields: PropTypes.bool,
  includeFieldSets: PropTypes.bool
};
WebformComponent.defaultProps = {
  t: null,
  displayValidationErrorBottom: null,
  scrollToTopAfterSubmit: true,
  scrollToTopAfterMultiFormStep: true,
  onlySubmitVisibleFields: false,
  includeFieldSets: false,
  onSuccessfullSubmit: function onSuccessfullSubmit(data) {},
  onFailedSubmit: function onFailedSubmit(data) {},
  initialValues: {},
  onSubmit: function onSubmit(values) {},
  onNextMultiFormStep: function onNextMultiFormStep() {},
  onPrevMultiFormStep: function onPrevMultiFormStep() {}
};

// TOOD: dont use webformState
function mapStateToProps(state, ownProps) {
  if (!state) {
    return {};
  }
  return {
    language: state.getIn(['ui', 'language']),
    webformState: state.getIn(['ui', 'webformState'])
  };
}
var WebformComponentTranslated = withTranslation()(WebformComponent);
export default connect(mapStateToProps)(WebformComponentTranslated);